export default __webpack_public_path__ + "static/media/Profile.dd47c812.png";